import { render } from "./GuiasPage.vue?vue&type=template&id=883742ce&scoped=true"
import script from "./GuiasPage.vue?vue&type=script&lang=js"
export * from "./GuiasPage.vue?vue&type=script&lang=js"

import "./GuiasPage.vue?vue&type=style&index=0&id=883742ce&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Repository\\C318-CAF. Portal de Juntas telematicas\\CAF-Solution\\NetCoreWebApi\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-883742ce"]])

export default __exports__